// extracted by mini-css-extract-plugin
export default {"header":"Summary_header__xN1zX","separator":"Summary_separator__IOAnI","edit":"Summary_edit__AAQD2","next":"Summary_next__-0tH3"};